module.exports = __webpack_public_path__ + "static/media/aFichier 7.42eb3013.svg";